import { cmdkFilter } from "./cmdk-filter"

// Every word in the query has to appear somewhere, so "company updates" still
// finds "Company relation updates".
export function matchesSearch(
	query: string,
	...values: Array<string | null | undefined>
): boolean {
	if (!query.trim()) {
		return true
	}

	const haystack = values.filter(Boolean).join(" ")
	return cmdkFilter(haystack, query) > 0
}
